const en = {
  dashboard_title: "Dashboard",
  dashboard_subtitle:
    "Overview of case property, custody status and important actions",
  case_property_register: "Case Properties",
  case_property_register_subtitle:
    "Track seized property, custody movement and court actions",
  case_property_summary: "Case property summary",
  total_case_properties: "Total Case Properties",
  current_reporting_scope: "Current reporting scope",
  added_this_month: "Added This Month",
  recorded_this_month: "Recorded during this month",
  disposed_this_month: "Disposed This Month",
  disposed_during_this_month: "Disposed during this month",
  balance_case_properties: "Balance Case Properties",
  properties_in_custody: "Properties currently in custody",
  selected_scope_info: "for the selected reporting scope",
  last_month: "Last month",
  dashboard_filters: "Dashboard filters",
  dashboard_partial_error:
    "Some dashboard information could not be loaded. Available information is still shown.",
  district: "District",
  all_districts: "All Districts",
  search_district: "Search district",
  assigned_district: "Assigned District",
  sub_division: "Sub-division",
  all_sub_divisions: "All Sub-divisions",
  search_sub_division: "Search sub-division",
  assigned_sub_division: "Assigned Sub-division",
  all_police_stations: "All Police Stations",
  search_police_station: "Search police station",
  assigned_police_station: "Assigned Police Station",
  user: "User",
  all_users: "All Users",
  search_user: "Search user",
  date_filter: "Date Filter",
  search_date_filter: "Search date filter",
  all_dates: "All Dates",
  custom_range: "Custom Range",
  select_date_range: "Select date range",
  reset: "Reset",
  not_accessible: "Not accessible",
  last_week: "Last Week",
  last_month_period: "Last Month",
  last_three_months: "Last 3 Months",
  last_six_months: "Last 6 Months",
  custom_date: "Custom Date",
  showing_all_records: "Showing all available records",
  export_report: "Export Report",
  updating_dashboard: "Updating dashboard…",
  view_register: "View register",
  case_property_by_status: "Case Property by Status",
  status_distribution_info: "Distribution by current custody status",
  properties: "Properties",
  type_distribution_info: "Distribution by recorded property type",
  case_property_by_type: "Case Property by Type",
  case_property_by_entry_type: "Case Property by Entry Type",
  vehicle_by_entry_type: "Vehicle by Entry Type",
  view_calendar: "View calendar",
  upcoming_court_dates: "Upcoming Court Dates",
  nearest_upcoming_dates_info:
    "Nearest upcoming court and charge-sheet dates",
  property_id: "Property ID",
  case_reference: "Case Reference",
  no_additional_details: "No additional details",
  hearing: "Hearing",
  charge_sheet: "Charge sheet",
  no_upcoming_dates:
    "No upcoming court dates are recorded for this scope.",
  view_all_court_dates: "View all court dates",
  view_all: "View all",
  total: "Total",
  count: "Count",
  top_5_property_types: "Top 5 Property Types",
  pending_follow_up_reason: "Pending / Follow-up Reason",
  cases_pending_action: "Cases Pending Action",
  date_time: "Date & Time",
  by: "By",
  recent_property_movements: "Recent Property Movements",
  no_type_data: "No property type data is available.",
  no_pending_reasons: "No pending reasons are recorded.",
  no_recent_movements: "No recent property movements are available.",
  other_property_types: "Other property types",
  other_custody_statuses: "Other custody statuses",
  other_pending_reasons: "Other pending reasons",
  case_reference_not_entered: "Case reference not entered",
  status_not_entered: "Status not entered",
  metric: "Metric",
  search_records: "Search records",
  search_placeholder:
    "Search by FIR, property ID, exhibit or description…",
  sort_records: "Sort records",
  search_sort_options: "Search sort options",
  latest_first: "Latest first",
  oldest_first: "Oldest first",
  sort_a_to_z: "A to Z",
  sort_z_to_a: "Z to A",
  serial_number: "Serial number",
  export_records: "Export records",
  add_case_property: "Add case property",
  case_and_law: "Case & Law",
  property_details: "Property Details",
  custody_status: "Custody Status",
  court_and_pendency: "Court & Pendency",
  updated_and_files: "Updated & Files",
  actions: "Actions",
  no_case_properties: "No case properties found",
  change_search_filters: "Try changing your search or filter criteria.",
  not_entered: "Not entered",
  exhibit: "Exhibit",
  seized: "Seized",
  acts_sections: "Acts / sections",
  other: "Other",
  updated: "Updated",
  custody_log: "Custody Log",
  court_date: "Court date",
  pendency: "Pendency",
  attachments: "Attachments",
  view: "View",
  more_actions: "More actions",
  edit_property: "Edit property",
  print_record: "Print record",
  view_attachments: "View attachments",
  pagination_label: "Case property register pagination",
  showing: "Showing",
  records: "records",
  rows_per_page: "Rows per page",
  go_to_first_page: "Go to first page",
  first_page: "First Page",
  go_to_previous_page: "Go to previous page",
  previous_page: "Previous Page",
  page: "Page",
  of: "of",
  go_to_page: "Go to page",
  go_to_next_page: "Go to next page",
  next_page: "Next Page",
  go_to_last_page: "Go to last page",
  last_page: "Last Page",
};

const gu = {
  dashboard_title: "ડેશબોર્ડ",
  dashboard_subtitle:
    "કેસ પ્રોપર્ટી, કસ્ટડી સ્થિતિ અને મહત્વપૂર્ણ કાર્યવાહીની ઝાંખી",
  case_property_register: "કેસ પ્રોપર્ટી રજીસ્ટર",
  case_property_register_subtitle:
    "જપ્ત મિલકત, કસ્ટડી હિલચાલ અને કોર્ટ કાર્યવાહીનું સંચાલન",
  case_property_summary: "કેસ પ્રોપર્ટી સારાંશ",
  total_case_properties: "કુલ કેસ પ્રોપર્ટી",
  current_reporting_scope: "વર્તમાન રિપોર્ટિંગ વિસ્તાર",
  added_this_month: "આ મહિને ઉમેરેલ",
  recorded_this_month: "આ મહિના દરમિયાન નોંધાયેલ",
  disposed_this_month: "આ મહિને નિકાલ કરેલ",
  disposed_during_this_month: "આ મહિના દરમિયાન નિકાલ કરેલ",
  balance_case_properties: "બાકી કેસ પ્રોપર્ટી",
  properties_in_custody: "હાલ કસ્ટડીમાં રહેલી મિલકતો",
  selected_scope_info: "પસંદ કરેલા રિપોર્ટિંગ વિસ્તાર માટે",
  last_month: "ગયા મહિને",
  dashboard_filters: "ડેશબોર્ડ ફિલ્ટર્સ",
  dashboard_partial_error:
    "ડેશબોર્ડની કેટલીક માહિતી લોડ થઈ શકી નથી. ઉપલબ્ધ માહિતી દર્શાવવામાં આવી છે.",
  district: "જિલ્લો",
  all_districts: "બધા જિલ્લાઓ",
  search_district: "જિલ્લો શોધો",
  assigned_district: "ફાળવેલ જિલ્લો",
  sub_division: "પેટા વિભાગ",
  all_sub_divisions: "બધા પેટા વિભાગો",
  search_sub_division: "પેટા વિભાગ શોધો",
  assigned_sub_division: "ફાળવેલ પેટા વિભાગ",
  all_police_stations: "બધા પોલીસ સ્ટેશનો",
  search_police_station: "પોલીસ સ્ટેશન શોધો",
  assigned_police_station: "ફાળવેલ પોલીસ સ્ટેશન",
  user: "વપરાશકર્તા",
  all_users: "બધા વપરાશકર્તાઓ",
  search_user: "વપરાશકર્તા શોધો",
  date_filter: "તારીખ ફિલ્ટર",
  search_date_filter: "તારીખ ફિલ્ટર શોધો",
  all_dates: "બધી તારીખો",
  custom_range: "પસંદગીની તારીખ મર્યાદા",
  select_date_range: "તારીખ મર્યાદા પસંદ કરો",
  reset: "રીસેટ",
  not_accessible: "ઍક્સેસ ઉપલબ્ધ નથી",
  last_week: "છેલ્લું અઠવાડિયું",
  last_month_period: "છેલ્લો મહિનો",
  last_three_months: "છેલ્લા 3 મહિના",
  last_six_months: "છેલ્લા 6 મહિના",
  custom_date: "પસંદગીની તારીખ",
  showing_all_records: "બધી ઉપલબ્ધ નોંધો દર્શાવવામાં આવી રહી છે",
  export_report: "રિપોર્ટ એક્સપોર્ટ કરો",
  updating_dashboard: "ડેશબોર્ડ અપડેટ થઈ રહ્યું છે…",
  view_register: "રજીસ્ટર જુઓ",
  case_property_by_status: "સ્થિતિ મુજબ કેસ પ્રોપર્ટી",
  status_distribution_info: "વર્તમાન કસ્ટડી સ્થિતિ મુજબ વિતરણ",
  properties: "મિલકતો",
  type_distribution_info: "નોંધાયેલ મિલકત પ્રકાર મુજબ વિતરણ",
  case_property_by_type: "પ્રકાર મુજબ કેસ પ્રોપર્ટી",
  view_calendar: "કેલેન્ડર જુઓ",
  upcoming_court_dates: "આગામી કોર્ટ તારીખો",
  nearest_upcoming_dates_info:
    "નજીકની આગામી કોર્ટ અને ચાર્જશીટ તારીખો",
  property_id: "પ્રોપર્ટી ID",
  case_reference: "કેસ સંદર્ભ",
  no_additional_details: "વધારાની વિગતો નથી",
  hearing: "સુનાવણી",
  charge_sheet: "ચાર્જશીટ",
  no_upcoming_dates: "આ વિસ્તાર માટે આગામી કોર્ટ તારીખ નોંધાયેલ નથી.",
  view_all_court_dates: "બધી કોર્ટ તારીખો જુઓ",
  view_all: "બધું જુઓ",
  total: "કુલ",
  count: "સંખ્યા",
  top_5_property_types: "ટોચના 5 પ્રોપર્ટી પ્રકાર",
  pending_follow_up_reason: "બાકી / અનુસરણ કારણ",
  cases_pending_action: "કાર્યવાહી બાકી કેસ",
  date_time: "તારીખ અને સમય",
  by: "દ્વારા",
  recent_property_movements: "તાજેતરની પ્રોપર્ટી હિલચાલ",
  no_type_data: "પ્રોપર્ટી પ્રકારનો ડેટા ઉપલબ્ધ નથી.",
  no_pending_reasons: "કોઈ બાકી કારણ નોંધાયેલ નથી.",
  no_recent_movements: "તાજેતરની પ્રોપર્ટી હિલચાલ ઉપલબ્ધ નથી.",
  other_property_types: "અન્ય પ્રોપર્ટી પ્રકારો",
  other_custody_statuses: "અન્ય કસ્ટડી સ્થિતિઓ",
  other_pending_reasons: "અન્ય બાકી કારણો",
  case_reference_not_entered: "કેસ સંદર્ભ દાખલ નથી",
  status_not_entered: "સ્થિતિ દાખલ નથી",
  metric: "માપદંડ",
  search_records: "નોંધો શોધો",
  search_placeholder: "FIR, પ્રોપર્ટી ID, એક્ઝિબિટ અથવા વિગત દ્વારા શોધો…",
  sort_records: "નોંધો ગોઠવો",
  search_sort_options: "ગોઠવણી વિકલ્પો શોધો",
  latest_first: "નવીનતમ પહેલા",
  oldest_first: "જૂના પહેલા",
  sort_a_to_z: "A થી Z",
  sort_z_to_a: "Z થી A",
  serial_number: "ક્રમ નંબર",
  export_records: "નોંધો એક્સપોર્ટ કરો",
  add_case_property: "કેસ પ્રોપર્ટી ઉમેરો",
  case_and_law: "કેસ અને કાયદો",
  property_details: "પ્રોપર્ટી વિગતો",
  custody_status: "કસ્ટડી સ્થિતિ",
  court_and_pendency: "કોર્ટ અને બાકી કાર્યવાહી",
  updated_and_files: "અપડેટ અને ફાઇલો",
  actions: "કાર્યવાહી",
  no_case_properties: "કોઈ કેસ પ્રોપર્ટી મળી નથી",
  change_search_filters: "શોધ અથવા ફિલ્ટર માપદંડ બદલીને જુઓ.",
  not_entered: "દાખલ નથી",
  exhibit: "એક્ઝિબિટ",
  seized: "જપ્ત",
  acts_sections: "કાયદા / કલમો",
  other: "અન્ય",
  updated: "અપડેટ",
  custody_log: "કસ્ટડી લોગ",
  court_date: "કોર્ટ તારીખ",
  pendency: "બાકી કાર્યવાહી",
  attachments: "જોડાણો",
  view: "જુઓ",
  more_actions: "વધુ કાર્યવાહી",
  edit_property: "પ્રોપર્ટી સંપાદિત કરો",
  print_record: "નોંધ પ્રિન્ટ કરો",
  view_attachments: "જોડાણો જુઓ",
  pagination_label: "કેસ પ્રોપર્ટી રજીસ્ટર પેજિનેશન",
  showing: "દર્શાવેલ",
  records: "નોંધો",
  rows_per_page: "દર પેજની પંક્તિઓ",
  go_to_first_page: "પ્રથમ પેજ પર જાઓ",
  first_page: "પ્રથમ પેજ",
  go_to_previous_page: "પાછલા પેજ પર જાઓ",
  previous_page: "પાછલું પેજ",
  page: "પેજ",
  of: "માંથી",
  go_to_page: "પેજ પર જાઓ",
  go_to_next_page: "આગલા પેજ પર જાઓ",
  next_page: "આગલું પેજ",
  go_to_last_page: "છેલ્લા પેજ પર જાઓ",
  last_page: "છેલ્લું પેજ",
};

const hi = {
  dashboard_title: "डैशबोर्ड",
  dashboard_subtitle:
    "केस संपत्ति, अभिरक्षा स्थिति और महत्वपूर्ण कार्रवाइयों का अवलोकन",
  case_property_register: "केस संपत्ति रजिस्टर",
  case_property_register_subtitle:
    "जब्त संपत्ति, अभिरक्षा गतिविधि और न्यायालय कार्रवाई का प्रबंधन",
  case_property_summary: "केस संपत्ति सारांश",
  total_case_properties: "कुल केस संपत्तियाँ",
  current_reporting_scope: "वर्तमान रिपोर्टिंग क्षेत्र",
  added_this_month: "इस महीने जोड़ी गई",
  recorded_this_month: "इस महीने दर्ज की गई",
  disposed_this_month: "इस महीने निस्तारित",
  disposed_during_this_month: "इस महीने के दौरान निस्तारित",
  balance_case_properties: "शेष केस संपत्तियाँ",
  properties_in_custody: "वर्तमान में अभिरक्षा में संपत्तियाँ",
  selected_scope_info: "चयनित रिपोर्टिंग क्षेत्र के लिए",
  last_month: "पिछला महीना",
  dashboard_filters: "डैशबोर्ड फ़िल्टर",
  dashboard_partial_error:
    "डैशबोर्ड की कुछ जानकारी लोड नहीं हो सकी। उपलब्ध जानकारी दिखाई जा रही है।",
  district: "जिला",
  all_districts: "सभी जिले",
  search_district: "जिला खोजें",
  assigned_district: "निर्धारित जिला",
  sub_division: "उप-विभाग",
  all_sub_divisions: "सभी उप-विभाग",
  search_sub_division: "उप-विभाग खोजें",
  assigned_sub_division: "निर्धारित उप-विभाग",
  all_police_stations: "सभी पुलिस स्टेशन",
  search_police_station: "पुलिस स्टेशन खोजें",
  assigned_police_station: "निर्धारित पुलिस स्टेशन",
  user: "उपयोगकर्ता",
  all_users: "सभी उपयोगकर्ता",
  search_user: "उपयोगकर्ता खोजें",
  date_filter: "दिनांक फ़िल्टर",
  search_date_filter: "दिनांक फ़िल्टर खोजें",
  all_dates: "सभी दिनांक",
  custom_range: "कस्टम अवधि",
  select_date_range: "दिनांक अवधि चुनें",
  reset: "रीसेट",
  not_accessible: "पहुँच उपलब्ध नहीं",
  last_week: "पिछला सप्ताह",
  last_month_period: "पिछला महीना",
  last_three_months: "पिछले 3 महीने",
  last_six_months: "पिछले 6 महीने",
  custom_date: "कस्टम दिनांक",
  showing_all_records: "सभी उपलब्ध रिकॉर्ड दिखाए जा रहे हैं",
  export_report: "रिपोर्ट निर्यात करें",
  updating_dashboard: "डैशबोर्ड अपडेट हो रहा है…",
  view_register: "रजिस्टर देखें",
  case_property_by_status: "स्थिति के अनुसार केस संपत्ति",
  status_distribution_info: "वर्तमान अभिरक्षा स्थिति के अनुसार वितरण",
  properties: "संपत्तियाँ",
  type_distribution_info: "दर्ज संपत्ति प्रकार के अनुसार वितरण",
  case_property_by_type: "प्रकार के अनुसार केस संपत्ति",
  view_calendar: "कैलेंडर देखें",
  upcoming_court_dates: "आगामी न्यायालय दिनांक",
  nearest_upcoming_dates_info:
    "निकटतम आगामी न्यायालय और चार्जशीट दिनांक",
  property_id: "संपत्ति ID",
  case_reference: "केस संदर्भ",
  no_additional_details: "कोई अतिरिक्त विवरण नहीं",
  hearing: "सुनवाई",
  charge_sheet: "चार्जशीट",
  no_upcoming_dates:
    "इस क्षेत्र के लिए कोई आगामी न्यायालय दिनांक दर्ज नहीं है।",
  view_all_court_dates: "सभी न्यायालय दिनांक देखें",
  view_all: "सभी देखें",
  total: "कुल",
  count: "संख्या",
  top_5_property_types: "शीर्ष 5 संपत्ति प्रकार",
  pending_follow_up_reason: "लंबित / अनुवर्ती कारण",
  cases_pending_action: "कार्रवाई हेतु लंबित केस",
  date_time: "दिनांक और समय",
  by: "द्वारा",
  recent_property_movements: "हाल की संपत्ति गतिविधियाँ",
  no_type_data: "संपत्ति प्रकार का डेटा उपलब्ध नहीं है।",
  no_pending_reasons: "कोई लंबित कारण दर्ज नहीं है।",
  no_recent_movements: "हाल की संपत्ति गतिविधि उपलब्ध नहीं है।",
  other_property_types: "अन्य संपत्ति प्रकार",
  other_custody_statuses: "अन्य अभिरक्षा स्थितियाँ",
  other_pending_reasons: "अन्य लंबित कारण",
  case_reference_not_entered: "केस संदर्भ दर्ज नहीं है",
  status_not_entered: "स्थिति दर्ज नहीं है",
  metric: "मापदंड",
  search_records: "रिकॉर्ड खोजें",
  search_placeholder: "FIR, संपत्ति ID, प्रदर्श या विवरण से खोजें…",
  sort_records: "रिकॉर्ड क्रमबद्ध करें",
  search_sort_options: "क्रम विकल्प खोजें",
  latest_first: "नवीनतम पहले",
  oldest_first: "सबसे पुराने पहले",
  sort_a_to_z: "A से Z",
  sort_z_to_a: "Z से A",
  serial_number: "क्रम संख्या",
  export_records: "रिकॉर्ड निर्यात करें",
  add_case_property: "केस संपत्ति जोड़ें",
  case_and_law: "केस और कानून",
  property_details: "संपत्ति विवरण",
  custody_status: "अभिरक्षा स्थिति",
  court_and_pendency: "न्यायालय और लंबित कार्रवाई",
  updated_and_files: "अपडेट और फ़ाइलें",
  actions: "कार्रवाइयाँ",
  no_case_properties: "कोई केस संपत्ति नहीं मिली",
  change_search_filters: "खोज या फ़िल्टर मानदंड बदलकर देखें।",
  not_entered: "दर्ज नहीं",
  exhibit: "प्रदर्श",
  seized: "जब्त",
  acts_sections: "अधिनियम / धाराएँ",
  other: "अन्य",
  updated: "अपडेट",
  custody_log: "अभिरक्षा लॉग",
  court_date: "न्यायालय दिनांक",
  pendency: "लंबित कार्रवाई",
  attachments: "संलग्नक",
  view: "देखें",
  more_actions: "अधिक कार्रवाइयाँ",
  edit_property: "संपत्ति संपादित करें",
  print_record: "रिकॉर्ड प्रिंट करें",
  view_attachments: "संलग्नक देखें",
  pagination_label: "केस संपत्ति रजिस्टर पृष्ठांकन",
  showing: "दिखा रहा है",
  records: "रिकॉर्ड",
  rows_per_page: "प्रति पृष्ठ पंक्तियाँ",
  go_to_first_page: "पहले पृष्ठ पर जाएँ",
  first_page: "पहला पृष्ठ",
  go_to_previous_page: "पिछले पृष्ठ पर जाएँ",
  previous_page: "पिछला पृष्ठ",
  page: "पृष्ठ",
  of: "में से",
  go_to_page: "पृष्ठ पर जाएँ",
  go_to_next_page: "अगले पृष्ठ पर जाएँ",
  next_page: "अगला पृष्ठ",
  go_to_last_page: "अंतिम पृष्ठ पर जाएँ",
  last_page: "अंतिम पृष्ठ",
};

const mr = {
  dashboard_title: "डॅशबोर्ड",
  dashboard_subtitle:
    "केस मालमत्ता, ताबा स्थिती आणि महत्त्वाच्या कारवाईचा आढावा",
  case_property_register: "केस मालमत्ता नोंदवही",
  case_property_register_subtitle:
    "जप्त मालमत्ता, ताबा हालचाल आणि न्यायालयीन कारवाईचे व्यवस्थापन",
  case_property_summary: "केस मालमत्ता सारांश",
  total_case_properties: "एकूण केस मालमत्ता",
  current_reporting_scope: "सध्याची अहवाल व्याप्ती",
  added_this_month: "या महिन्यात जोडले",
  recorded_this_month: "या महिन्यात नोंदवले",
  disposed_this_month: "या महिन्यात विल्हेवाट",
  disposed_during_this_month: "या महिन्यात विल्हेवाट लावले",
  balance_case_properties: "शिल्लक केस मालमत्ता",
  properties_in_custody: "सध्या ताब्यातील मालमत्ता",
  selected_scope_info: "निवडलेल्या अहवाल व्याप्तीसाठी",
  last_month: "मागील महिना",
  dashboard_filters: "डॅशबोर्ड फिल्टर",
  dashboard_partial_error:
    "डॅशबोर्डची काही माहिती लोड होऊ शकली नाही. उपलब्ध माहिती दाखवली आहे.",
  district: "जिल्हा",
  all_districts: "सर्व जिल्हे",
  search_district: "जिल्हा शोधा",
  assigned_district: "नेमलेला जिल्हा",
  sub_division: "उपविभाग",
  all_sub_divisions: "सर्व उपविभाग",
  search_sub_division: "उपविभाग शोधा",
  assigned_sub_division: "नेमलेला उपविभाग",
  all_police_stations: "सर्व पोलीस ठाणी",
  search_police_station: "पोलीस ठाणे शोधा",
  assigned_police_station: "नेमलेले पोलीस ठाणे",
  user: "वापरकर्ता",
  all_users: "सर्व वापरकर्ते",
  search_user: "वापरकर्ता शोधा",
  date_filter: "तारीख फिल्टर",
  search_date_filter: "तारीख फिल्टर शोधा",
  all_dates: "सर्व तारखा",
  custom_range: "सानुकूल कालावधी",
  select_date_range: "तारीख कालावधी निवडा",
  reset: "रीसेट",
  not_accessible: "प्रवेश उपलब्ध नाही",
  last_week: "मागील आठवडा",
  last_month_period: "मागील महिना",
  last_three_months: "मागील 3 महिने",
  last_six_months: "मागील 6 महिने",
  custom_date: "सानुकूल तारीख",
  showing_all_records: "सर्व उपलब्ध नोंदी दाखवत आहे",
  export_report: "अहवाल निर्यात करा",
  updating_dashboard: "डॅशबोर्ड अद्ययावत होत आहे…",
  view_register: "नोंदवही पहा",
  case_property_by_status: "स्थितीनुसार केस मालमत्ता",
  status_distribution_info: "सध्याच्या ताबा स्थितीनुसार वितरण",
  properties: "मालमत्ता",
  type_distribution_info: "नोंदवलेल्या मालमत्ता प्रकारानुसार वितरण",
  case_property_by_type: "प्रकारानुसार केस मालमत्ता",
  view_calendar: "दिनदर्शिका पहा",
  upcoming_court_dates: "आगामी न्यायालयीन तारखा",
  nearest_upcoming_dates_info:
    "जवळच्या आगामी न्यायालय आणि आरोपपत्र तारखा",
  property_id: "मालमत्ता ID",
  case_reference: "प्रकरण संदर्भ",
  no_additional_details: "अतिरिक्त तपशील नाही",
  hearing: "सुनावणी",
  charge_sheet: "आरोपपत्र",
  no_upcoming_dates:
    "या व्याप्तीसाठी आगामी न्यायालयीन तारीख नोंदलेली नाही.",
  view_all_court_dates: "सर्व न्यायालयीन तारखा पहा",
  view_all: "सर्व पहा",
  total: "एकूण",
  count: "संख्या",
  top_5_property_types: "शीर्ष 5 मालमत्ता प्रकार",
  pending_follow_up_reason: "प्रलंबित / पाठपुरावा कारण",
  cases_pending_action: "कारवाई प्रलंबित प्रकरणे",
  date_time: "तारीख आणि वेळ",
  by: "द्वारे",
  recent_property_movements: "अलीकडील मालमत्ता हालचाली",
  no_type_data: "मालमत्ता प्रकाराचा डेटा उपलब्ध नाही.",
  no_pending_reasons: "कोणतेही प्रलंबित कारण नोंदलेले नाही.",
  no_recent_movements: "अलीकडील मालमत्ता हालचाल उपलब्ध नाही.",
  other_property_types: "इतर मालमत्ता प्रकार",
  other_custody_statuses: "इतर ताबा स्थिती",
  other_pending_reasons: "इतर प्रलंबित कारणे",
  case_reference_not_entered: "प्रकरण संदर्भ नोंदवलेला नाही",
  status_not_entered: "स्थिती नोंदवलेली नाही",
  metric: "मापदंड",
  search_records: "नोंदी शोधा",
  search_placeholder: "FIR, मालमत्ता ID, प्रदर्श किंवा वर्णनाने शोधा…",
  sort_records: "नोंदी क्रमबद्ध करा",
  search_sort_options: "क्रम पर्याय शोधा",
  latest_first: "नवीनतम प्रथम",
  oldest_first: "सर्वात जुने प्रथम",
  sort_a_to_z: "A ते Z",
  sort_z_to_a: "Z ते A",
  serial_number: "अनुक्रमांक",
  export_records: "नोंदी निर्यात करा",
  add_case_property: "केस मालमत्ता जोडा",
  case_and_law: "प्रकरण आणि कायदा",
  property_details: "मालमत्ता तपशील",
  custody_status: "ताबा स्थिती",
  court_and_pendency: "न्यायालय आणि प्रलंबित",
  updated_and_files: "अद्यतन आणि फायली",
  actions: "कारवाई",
  no_case_properties: "केस मालमत्ता सापडली नाही",
  change_search_filters: "शोध किंवा फिल्टर निकष बदलून पहा.",
  not_entered: "नोंदवलेले नाही",
  exhibit: "प्रदर्श",
  seized: "जप्त",
  acts_sections: "कायदे / कलमे",
  other: "इतर",
  updated: "अद्यतन",
  custody_log: "ताबा नोंद",
  court_date: "न्यायालयीन तारीख",
  pendency: "प्रलंबित",
  attachments: "संलग्नक",
  view: "पहा",
  more_actions: "अधिक कारवाई",
  edit_property: "मालमत्ता संपादित करा",
  print_record: "नोंद मुद्रित करा",
  view_attachments: "संलग्नक पहा",
  pagination_label: "केस मालमत्ता नोंदवही पृष्ठांकन",
  showing: "दाखवत आहे",
  records: "नोंदी",
  rows_per_page: "प्रति पृष्ठ ओळी",
  go_to_first_page: "पहिल्या पृष्ठावर जा",
  first_page: "पहिले पृष्ठ",
  go_to_previous_page: "मागील पृष्ठावर जा",
  previous_page: "मागील पृष्ठ",
  page: "पृष्ठ",
  of: "पैकी",
  go_to_page: "पृष्ठावर जा",
  go_to_next_page: "पुढील पृष्ठावर जा",
  next_page: "पुढील पृष्ठ",
  go_to_last_page: "शेवटच्या पृष्ठावर जा",
  last_page: "शेवटचे पृष्ठ",
};

export const UI_TRANSLATIONS = { en, gu, hi, mr };

export const getUiTranslation = (language, key) =>
  UI_TRANSLATIONS[language]?.[key] || en[key] || key;
